<script lang="ts" setup>
import { useI18n } from 'vue-i18n';

import type { AppSingleSelectOption } from '@libs/ui';
import { AppSingleSelect } from '@libs/ui';
import { TransportType } from '@libs/trip-planner-interfaces';

interface ExperimanetalTrasportSelectorEmits {
  (eventName: 'select-transport', value: TransportType): void;
}
const emit = defineEmits<ExperimanetalTrasportSelectorEmits>();

const { t } = useI18n();

function selectTransport(transport: TransportType): void {
  emit('select-transport', transport);
}

const transportOptions: AppSingleSelectOption<TransportType>[] = [
  {
    id: TransportType.Flight,
    label: `${t('planner.transport.flight')}`,
    icon: 'airplane',
  },
  {
    id: TransportType.Ferry,
    label: `${t('planner.transport.ferry')}`,
    icon: 'ferry',
  },
  {
    id: TransportType.Car,
    label: `${t('planner.transport.car')}`,
    icon: 'car',
  },
  {
    id: TransportType.Walk,
    label: `${t('planner.transport.walking')}`,
    icon: 'personWalking',
  },
  {
    id: TransportType.Bicycle,
    label: `${t('planner.transport.bicycle')}`,
    icon: 'personBicycling',
  },
];
</script>

<template>
  <div class="experimental-transport-selector">
    <AppSingleSelect
      class="experimental-transport-single-selector"
      type="summer"
      :options="transportOptions"
      :placeholder="t('planner.transport.experiment.add_transport')"
      left-side-icon="plus"
      :selected="null"
      extra-label="test"
      @select="selectTransport($event.id)"
    >
      <template #extraLabel>
        {{ $t('planner.transport.experiment.add_transport_text') }}
      </template>
    </AppSingleSelect>
  </div>
</template>

<style lang="scss" scoped>
.experimental-transport-selector {
  display: flex;
  .experimental-transport-single-selector {
    box-shadow: var(--shadow-elevation-20);
    border-radius: var(--border-radius-8);
  }
}
</style>
